import * as React from 'react'

import {Select} from '@ua/design-system/components/select'

import {MessageTypes} from '../types'

interface Props {
  name: string
  selected: string | undefined
  onSelect: (arg: string) => void
  items: MessageTypes[]
  defaultItemText?: string
  optionalLabel?: boolean
}

const AdditionalSelect: React.FC<Props> = ({
  name,
  selected,
  onSelect,
  items,
  defaultItemText,
  optionalLabel,
}) => {
  const isOptional = optionalLabel ? '(Optional)' : ''

  return (
    <Select
      label={`${name} ${isOptional}`}
      onChange={(e) => onSelect(e.target.value)}
      placeholder={defaultItemText}
      value={selected}
    >
      {items.map((item) => (
        <option key={item.id} value={item.id}>
          {item.label}
        </option>
      ))}
    </Select>
  )
}

export default AdditionalSelect
